import getStripeSubscriptionStatus from '../../services/clients/billing';

export default {
  state: {
    clients: {},
    alerts: false,
  },
  actions: {
    async GET_STRIPE_SUBSCRIPTION_STATUS({ commit }) {
      const json = await getStripeSubscriptionStatus();
      commit('UPDATE_STRIPE_SUBSCRIPTION_STATUS', json.data);
      commit('UPDATE_STRIPE_ALERT_STATUS', json.alerts);
      return json;
    },
  },
  mutations: {
    UPDATE_STRIPE_SUBSCRIPTION_STATUS(state, payload) {
      state.clients = payload;
    },
    UPDATE_STRIPE_ALERT_STATUS(state, payload) {
      state.alerts = payload;
    },
  },
  getters: {
    clients({ clients }) {
      return clients;
    },
    alerts({ alerts }) {
      return alerts;
    },
  },
};
